import ComponentHelper from '../../supers/ComponentHelper';
import React from 'react';
import './list-panel.css';

class ListPanel extends ComponentHelper {
	buildLabels(labels) {
		let items = [];
		for (let i = 0; i < labels.length; i++) {
			if (labels[i].length === 0) {
				items.push(<div className="grow-1" key={`list-label-${i}`} />);
			} else {
				items.push(
					<div className={`label grow-1 ${labels[i]}`} key={`list-label-key-${labels[i]}`}>
						{labels[i]}
					</div>
				);
			}
		}
		return items;
	}

	render() {
		let { className, name, listItems, labels, onCreate, headerItems } = this.props;
		return (
			<div className={`list-panel-cmp panel ${className ? className : ''}`}>
				<div className="list-header hbox vcenter">
					<div className="title grow-1">{name}</div>
					{headerItems}
					{onCreate && (
						<button className="btn primary square vbox hcenter vcenter" onClick={onCreate}>
							<i className="mdi mdi-plus" />
						</button>
					)}
				</div>
				<div className="list-labels hbox vcenter">
					<div className="spacer" />
					{this.buildLabels(labels)}
				</div>
				<div className="list-items">{listItems}</div>
			</div>
		);
	}
}

export default ListPanel;



// WEBPACK FOOTER //
// ./src/components/list-panel/ListPanel.js